import { GlobalMessageContext } from 'App'
import { DateTime } from 'luxon'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLazyGetAuthTokenWithRefreshTokenQuery } from 'store/apis/authApi'
import metricsApi from 'store/apis/metricsApi'
import postsApi from 'store/apis/posts/postsApi'
import { selectAuthToken, selectIsLoggedIn, selectRefreshToken } from 'store/apis/selectors'
import userApi from 'store/apis/userApi'
import { logout } from 'store/slices/authSlice'
import { useAppDispatch, useAppSelector } from 'store/store'

export default function useAuthBeforeMutation(mutation: any) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { authTokenExpires } = useAppSelector(selectAuthToken)
  const refreshToken = useAppSelector(selectRefreshToken)
  const isLoggedIn = useAppSelector(selectIsLoggedIn)

  const { setGlobalMessage } = useContext(GlobalMessageContext)

  const [mutationMethod, mutationObject] = mutation()

  const [getAuthTokenWithRefreshToken] = useLazyGetAuthTokenWithRefreshTokenQuery()

  const checkAuth = async (params: any) => {
    const sessionHasExpired = authTokenExpires && authTokenExpires <= DateTime.now()

    if (!isLoggedIn || sessionHasExpired) {
      let message = 'You must login first'

      if (sessionHasExpired && refreshToken) {
        message = 'Your session has expired'

        const response = await getAuthTokenWithRefreshToken(refreshToken).unwrap()

        if (response.access_token) {
          await mutationMethod(params).unwrap()

          return
        }
      }

      dispatch(logout())
      dispatch(userApi.util.resetApiState())
      dispatch(metricsApi.util.resetApiState())
      dispatch(postsApi.util.resetApiState())

      setGlobalMessage({
        type: 'warning',
        message: message,
      })

      navigate('/subscribe')
    }

    await mutationMethod(params).unwrap()
  }

  return [checkAuth, mutationObject]
}
